import { Grid } from '@mui/material';

import { WorkOrderData } from '../../../api/workOrders/types';
import { Constants } from './constants';
import { InputTitle, StyledInput } from './styles';

interface VVMResponsibleProps {
  propertyData: WorkOrderData | undefined;
}

export function VVMResponsible({
  propertyData,
}: VVMResponsibleProps): JSX.Element {
  return (
    <Grid container spacing={4}>
      <Grid item xl={4}>
        <InputTitle>{Constants.responsibleName}</InputTitle>
        <StyledInput>{propertyData?.vvm_responsible}</StyledInput>
      </Grid>
      <Grid item xl={4}>
        <InputTitle>{Constants.emailResponsible}</InputTitle>
        <StyledInput>{propertyData?.vvm_responsible_email}</StyledInput>
      </Grid>
      <Grid item xl={4}>
        <InputTitle>{Constants.phoneResponsible}</InputTitle>
        <StyledInput>{propertyData?.vvm_responsible_phone_number}</StyledInput>
      </Grid>
    </Grid>
  );
}
